import React from "react";
import "./Footer.css";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaLinkedin,
} from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Left */}
        <div className="footer-col">
          <img src="/logo.png" alt="logo" className="footer-logo" />

          <p className="footer-text">
            RelyOnne UK is a trusted supplier of premium paper and board
            products across the United Kingdom. Contact us to discuss your
            requirements.
          </p>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h3>Get In Touch</h3>

          <div className="footer-item">
            <FaMapMarkerAlt className="icon" />
            <span>
              London
            </span>
          </div>

          <div className="footer-item">
            <FaEnvelope className="icon" />
            <a href="mailto:contact@relyonneuk.com">
              contact@relyonneuk.com
            </a>
          </div>

          <div className="footer-item">
            <FaPhoneAlt className="icon" />
            <a href="tel:+447515866571">
              +44 7515866571
            </a>
          </div>
        </div>

        {/* Links */}
        <div className="footer-col">
          <ul className="footer-links">
            <li>
              <a href="/">Home</a>
            </li>

            <li>
              <a href="https://relyonneuk.com/who-we-are">
                Who We Are
              </a>
            </li>

            <li>
              <a href="https://relyonneuk.com/products">
                Products
              </a>
            </li>

            <li>
              <a href="https://relyonneuk.com/contact">
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Social */}
        <div className="footer-col">
          <a
            href="https://www.linkedin.com/"
            target="_blank"
            rel="noreferrer"
            className="linkedin"
          >
            <FaLinkedin />
          </a>

          <p className="footer-text">
            Follow us on LinkedIn for company news, product updates and special
            offers.
          </p>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} RelyOnne UK. All Rights Reserved.
      </div>
    </footer>
  );
}

export default Footer;
